import { setLoader } from "../../../store/slices/loaderSlice";

export function withLoaderAndSideEffects(queryFn: any): any {
    return async (arg: any, queryApi: any, extra: any, fetch: any) => {
        const dispatch = queryApi.dispatch;
        const { globalLoader = true } = arg;
        try {
            if (globalLoader) dispatch(setLoader(globalLoader));
            const result = await queryFn(arg, queryApi, extra, fetch);
            return result;
        } catch (error) {
            console.error('Error in query:', error);
            return { error };
        } finally {
            if (globalLoader) dispatch(setLoader(false));
        }
    };
}

export function withOnQueryStarted() {
    return async (arg: any, queryApi: any) => {
        const dispatch = queryApi.dispatch;
        const { globalLoader = true } = arg;
        try {
            if (globalLoader) dispatch(setLoader(globalLoader));
            await queryApi.queryFulfilled;
        } catch (error) {
            console.error('Error in onQueryStarted:', error);
        }
        finally {
            if (globalLoader) dispatch(setLoader(false));
        }
    };
}
